import { Injectable } from '@angular/core';
import { DragAndDropConfigs, DragAndDropFile, DragAndDropReport, FILE_ERROR_TYPE } from './core/drag-and-drop.model';
import { TranslationService } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class DragAndDropService {
  constructor(private translationService: TranslationService) {}

  formatFileSize(size: number): string {
    if (size < 1024) return size + ' bytes';
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB'];
    return (size / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
  }

  validateFiles(items: DragAndDropFile[], config: DragAndDropConfigs): DragAndDropReport {
    const response: DragAndDropReport = { items: [] };

    if (items) {
      if (items.length > config.maxFiles) {
        this.translationService.translate('dragAndDrop.maxFilesExceeded', { maxFiles: config.maxFiles }).subscribe((translation: string) => {
          response.genericError = {
            message: translation,
            type: FILE_ERROR_TYPE.MAX_FILES,
          };
        });
      }

      items.forEach(item => {
        const fileExtension = item?.file?.name?.split('.')?.pop()?.toLowerCase() || '';
        const dropedFile: DragAndDropFile = { file: undefined, errors: [] };
        dropedFile.file = item.file;

        if (item?.file && item.file.size > config.maxFileSize) {
          this.translationService.translate('dragAndDrop.fileSizeExceedsLimit', { fileName: item.file?.name }).subscribe((translation: string) => {
            dropedFile.errors.push({
              message: translation,
              type: FILE_ERROR_TYPE.MAX_FILE_SIZE,
            });
          });
        }

        if (!config.allowedFileTypes.includes(fileExtension)) {
          this.translationService.translate('dragAndDrop.invalidFileType', { fileName: item.file?.name }).subscribe((translation: string) => {
            dropedFile.errors.push({
              message: translation,
              type: FILE_ERROR_TYPE.ALLOWED_FILE_TYPES,
            });
          });
        }

        response.items?.push(dropedFile);
      });
    }

    return response;
  }
}